"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_REFERENCE_GRAMMAR_ID = void 0;
exports["default"] = setReferenceGrammarID;
var SET_REFERENCE_GRAMMAR_ID = 'WEB_CHAT/SET_REFERENCE_GRAMMAR_ID';
exports.SET_REFERENCE_GRAMMAR_ID = SET_REFERENCE_GRAMMAR_ID;
function setReferenceGrammarID(referenceGrammarID) {
  return {
    type: SET_REFERENCE_GRAMMAR_ID,
    payload: {
      referenceGrammarID: referenceGrammarID
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRVRfUkVGRVJFTkNFX0dSQU1NQVJfSUQiLCJleHBvcnRzIiwic2V0UmVmZXJlbmNlR3JhbW1hcklEIiwicmVmZXJlbmNlR3JhbW1hcklEIiwidHlwZSIsInBheWxvYWQiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9zZXRSZWZlcmVuY2VHcmFtbWFySUQuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0VUX1JFRkVSRU5DRV9HUkFNTUFSX0lEID0gJ1dFQl9DSEFUL1NFVF9SRUZFUkVOQ0VfR1JBTU1BUl9JRCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHNldFJlZmVyZW5jZUdyYW1tYXJJRChyZWZlcmVuY2VHcmFtbWFySUQpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTRVRfUkVGRVJFTkNFX0dSQU1NQVJfSUQsXG4gICAgcGF5bG9hZDogeyByZWZlcmVuY2VHcmFtbWFySUQgfVxuICB9O1xufVxuXG5leHBvcnQgeyBTRVRfUkVGRVJFTkNFX0dSQU1NQVJfSUQgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLHdCQUF3QixHQUFHLG1DQUFtQztBQUFDQyxPQUFBLENBQUFELHdCQUFBLEdBQUFBLHdCQUFBO0FBRXRELFNBQVNFLHFCQUFxQkEsQ0FBQ0Msa0JBQWtCLEVBQUU7RUFDaEUsT0FBTztJQUNMQyxJQUFJLEVBQUVKLHdCQUF3QjtJQUM5QkssT0FBTyxFQUFFO01BQUVGLGtCQUFrQixFQUFsQkE7SUFBbUI7RUFDaEMsQ0FBQztBQUNIIn0=